import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderMainComponent } from './header/header-main.component';
import { FooterMainComponent } from './footer/footer-main.component';
import { TopMenuComponent } from './menus/top-menu/top-menu.component';
import { LeftMenuComponent } from './menus/left-menu/left-menu.component';
import { SideBarComponent } from './menus/side-bar/side-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { FieldControlComponent } from './field/field-control.component';
import { FieldReferenceEditorComponent } from './field-reference-editor/field-reference-editor.component';
import { UploadFieldComponent } from './field/upload-field/upload-field.component';
import { FieldValidation } from './field-validation/field-validation.component';
import { DynamicLeftMenuComponent } from './menus/dynamic-left-menu/dynamic-left-menu.component';
import { MenuHeaderComponent } from './menus/menu-header/menu-header.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AssetsLeftMenuComponent } from './menus/assets-left-menu/assets-left-menu.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ContentEditionComponent } from './content/content-edition/content-edition.component';
import { ContentsListingComponent } from './content/contents-listing/contents-listing.component';
import { MonacoLiquidEditorModule } from './monaco-liquid-editor/monaco-liquid-editor.module';
import { NgxFileDropModule } from './ngx-file-drop/ngx-file-drop.module';
import { CKEditorModule } from 'ckeditor4-angular';
import { SideLeftBarComponent } from './menus/side-left-bar/side-left-bar.component';
import { MenuComponent } from './menus/menu/menu.component';
import { MenuItemComponent } from './menus/menu/menu-item/menu-item.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FieldPipe } from './field/pipes/field-pipe';
import { IsDefaultLanguagePipe } from './pipes/language/is-default-language.pipe';
import { GetValidationMsgsPipe } from './content/content-edition/pipes/get-validation-msgs.pipe';
import { GetPublishFormGroupScheduleJobDueTimePipe } from './content/content-edition/pipes/get-publish-form-group-schedule-job-due-time.pipe';
import { GetLocalizedFieldControlNamePipe } from './field/pipes/get-localized-field-control-name.pipe';
import { GetValuePipe } from './field/pipes/get-value.pipe';
import { FormGroupGetPipe } from './field/pipes/form-group-get.pipe';
import { GetDateValuePipe } from './field/pipes/get-date-value.pipe';
import { GetDateTimeValuePipe } from './field/pipes/get-date-time-value.pipe';
import { GetMenuLabelPipe } from './field/pipes/get-menu-label.pipe'
import { GetMenuSelectedChildrenPipe } from './field/pipes/get-menu-selected-children-pipe'
import { GetMenuShowPlusIconPipe } from './field/pipes/get-menu-show-plus-icon-pipe'
import { GetMenuShowMinusIconPipe } from './field/pipes/get-menu-show-minus-icon-pipe'
import { GetMenuDisabledPipe } from './field/pipes/get-menu-disabled-pipe'
import { GetCultureNamePipe } from './field/pipes/get-culture-name.pipe'
import { GetCompareValuePipe } from './field/pipes/get-compare-value.pipe';
import { GetLanguageCodePipe } from './field/pipes/get-language-code.pipe';
import { FormGroupGetLocalizedPipe } from './field/pipes/form-group-get-localized.pipe';

@NgModule(
  {
    declarations: [
      HeaderMainComponent,
      FooterMainComponent,
      ContentsListingComponent,
      ContentEditionComponent,
      TopMenuComponent,
      LeftMenuComponent,
      SideBarComponent,
      SideLeftBarComponent,
      FieldControlComponent,
      FieldReferenceEditorComponent,
      UploadFieldComponent,
      FieldValidation,
      DynamicLeftMenuComponent,
      MenuHeaderComponent,
      AssetsLeftMenuComponent,
      MenuComponent,
      MenuItemComponent,
      FieldPipe,
      IsDefaultLanguagePipe,
      GetValidationMsgsPipe,
      GetPublishFormGroupScheduleJobDueTimePipe,
      GetLocalizedFieldControlNamePipe,
      GetValuePipe,
      FormGroupGetPipe,
      GetDateValuePipe,
      GetDateTimeValuePipe,
      GetMenuLabelPipe,
      GetMenuSelectedChildrenPipe,
      GetMenuShowPlusIconPipe,
      GetMenuShowMinusIconPipe,
      GetMenuDisabledPipe,
      GetCultureNamePipe,
      GetCompareValuePipe,
      GetMenuDisabledPipe,
      GetLanguageCodePipe,
      FormGroupGetLocalizedPipe
    ],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      TranslateModule,
      BsDatepickerModule.forRoot(),
      AccordionModule.forRoot(),
      CKEditorModule,
      DragDropModule,
      NgxFileDropModule,
      MonacoLiquidEditorModule,
      NgMultiSelectDropDownModule.forRoot(),
      BsDropdownModule.forRoot(),
      PaginationModule.forRoot(),
      TabsModule.forRoot()
    ],
    exports: [
      FooterMainComponent,
      HeaderMainComponent,
      LeftMenuComponent,
      DynamicLeftMenuComponent,
      SideBarComponent,
      SideLeftBarComponent,
      ContentsListingComponent,
      ContentEditionComponent,
      FieldValidation,
      FieldControlComponent,
      UploadFieldComponent,
      AssetsLeftMenuComponent,
      MenuComponent,
      MenuItemComponent,
      FieldPipe,
      IsDefaultLanguagePipe,
      GetMenuLabelPipe,
      GetMenuSelectedChildrenPipe,
      GetMenuShowMinusIconPipe,
      GetMenuShowMinusIconPipe,
      GetMenuDisabledPipe,
      GetCultureNamePipe,
      GetCompareValuePipe,
      GetLanguageCodePipe,
      GetLocalizedFieldControlNamePipe,
      FormGroupGetLocalizedPipe,
      FormGroupGetPipe
    ]
  })
export class SharedModule { }
